<template lang="pug">
  .w-full
    .flex.items-center.cursor-pointer.select-none.my-2(@click="open = !open")
      slot
      .flex-shrink-0.ml-auto.transition-all.duration-300.ease-out(:class="open ? 'transform -rotate-180' : ''")
        sw-icon(name="arrow-down" size="w-3 h-3")
    transition(@enter="expand" @after-enter="resetExpandable" @leave="collapse" @after-leave="resetExpandable")
      .transition-all.ease-out.duration-300.opacity-0x(v-show="open")
        slot(name="in-collapse")
</template>

<script>
export default {
  data () {
    return {
      open: true,
    };
  },
  methods: {
    expand (element) {
      const height = getComputedStyle(element).height;
      element.style.overflow = 'hidden';
      element.style.height = 0;
      element.style.opacity = 1;
      requestAnimationFrame(() => {
        element.style.height = height;
      });
      this.$emit('expand');
    },
    collapse (element) {
      element.style.overflow = 'hidden';
      element.style.height = getComputedStyle(element).height;
      element.style.opacity = 0;
      requestAnimationFrame(() => {
        element.style.height = 0;
      });
      this.$emit('collapse');
    },
    resetExpandable (element) {
      element.style.overflow = null;
      element.style.height = null;
    },
  },
};
</script>
